// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___xbX7","fullView":"styles_fullView__1-pyE"};